import colors from '@wecasa/common/src/utils/colors';
import { formatPricePerHour } from '@wecasa/common/src/utils/formatting';

import type { SurchargesPrice } from '@wecasa/customer/src/types/prices';

import { translate } from '@wecasa/i18n';

import Text from '@wecasa/web-ui/src/components/base-text/variants/text';

import { CategoryLine, SurchargeLine, SurchargeTitle } from '../../../../common/common';

const t = translate('basket');

type SurchargesCleaningProps = {
  surcharges?: SurchargesPrice[];
};

const Surcharges = ({ surcharges }: SurchargesCleaningProps) => {
  const hasAppointmentSurcharge = surcharges && surcharges.length > 0;

  if (!hasAppointmentSurcharge) return null;

  return (
    <CategoryLine>
      <SurchargeTitle display='block'>{t('.surcharge.title', { count: surcharges.length })}</SurchargeTitle>
      {surcharges.map((surcharge) => (
        <SurchargeLine key={surcharge.type}>
          <Text>{t(`.appointment_surcharge.${surcharge.type}`)}</Text>
          <Text.SM color={colors.ink50}>{formatPricePerHour(surcharge.hourly_price)}</Text.SM>
        </SurchargeLine>
      ))}
    </CategoryLine>
  );
};

export default Surcharges;
